import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Flex } from '@chakra-ui/react';
import PoweredByCapsule from './assets/poweredByCapsule';
export function Footer() {
    return (_jsx(Box, { height: "62px", width: "100%", children: _jsx(Flex, { h: "57px", w: "100%", justifyContent: 'center', alignItems: 'center', children: _jsx(PoweredByCapsule, { w: 50, h: 20 }) }) }));
}
